export const PET_STORE_BASE_LINK = 'https://madpaws.petchemist.com.au';
export const PET_CHEMIST_BASE_LINK = 'https://petchemist.com.au';
export const WAGGLY_BASE_LINK = 'https://waggly.com.au';
export const SASH_BASE_LINK = 'https://www.sashbeds.com';

export const HELP_CENTRE_LINK = 'https://madpaws.brainfi.sh/';
export const RWB_CANCELLATION_POLICY_LINK = `${HELP_CENTRE_LINK}articles/what-is-the-cancellation-and-refund-policy-for-repeat-weekly-bookings-ysTRx8PNrN`;
